export const FINANCE_DEPT_DATA = {
  health: {
    score: 86,
    trend: '+1',
    status: 'green',
    summary: 'Cash position strong at $2.1M. Burn rate stable at $185K/month. Revenue tracking 4% ahead of Q1 forecast. One budget overrun flagged in Marketing (Meta spend).',
  },

  agents: [
    {
      id: 'finn',
      name: 'Finn',
      role: 'Finance Intelligence AI',
      status: 'active',
      currentTask: 'Reconciling January actuals vs. forecast — variance report ready by 3 PM',
      lastAction: 'Flagged Marketing budget overrun: Meta Ads $2,100 over approved budget',
      lastActionTime: '45 min ago',
    },
  ],

  alerts: [
    {
      id: 'fa1',
      title: 'Marketing Meta Ads budget overrun — $2,100 over approved spend',
      severity: 'medium',
      agents: ['finn'],
      description: 'Meta Ads spent $4,600 vs. $2,500 approved budget (84% over). ROI is 0.8x — underperforming. Marsi had already recommended reallocating this budget to LinkedIn.',
      actions: [
        { agent: 'finn', label: 'Flagged overrun to Priya with spend breakdown', status: 'complete' },
        { agent: 'finn', label: 'Cross-referenced with Marsi — budget reallocation already recommended', status: 'complete' },
        { agent: 'finn', label: 'Updated forecast to reflect actual Meta spend', status: 'complete' },
      ],
    },
    {
      id: 'fa2',
      title: 'Q2 runway projection: 11.4 months at current burn rate',
      severity: 'medium',
      agents: ['finn'],
      description: 'Cash position is $2.1M with $185K/month burn. Runway is comfortable but contracts with 2 Enterprise clients ($168K combined) are pending renewal. Non-renewal would reduce runway to 9.8 months.',
      actions: [
        { agent: 'finn', label: 'Modeled 3 scenarios: best case (both renew), base (1 renews), worst (neither)', status: 'complete' },
        { agent: 'finn', label: 'Identified $22K/month in non-essential expenses that could extend runway', status: 'complete' },
        { agent: 'finn', label: 'Recommend contingency reserve of $50K for renewal risk', status: 'recommended' },
      ],
    },
    {
      id: 'fa3',
      title: '3 vendor invoices overdue — $14,200 pending payment',
      severity: 'medium',
      agents: ['finn'],
      description: 'AWS ($8,400), Figma ($3,200), and HubSpot ($2,600) invoices are past due. AWS and Figma are 10+ days overdue. No disputes — just processing delays.',
      actions: [
        { agent: 'finn', label: 'Queued all 3 invoices for immediate payment processing', status: 'in-progress' },
        { agent: 'finn', label: 'Set up automated payment reminders to prevent future delays', status: 'recommended' },
      ],
    },
  ],

  decisions: [
    { id: 'fd1', title: 'Approve $50K contingency reserve for Enterprise renewal risk', agent: 'finn', urgency: 'medium', detail: 'TechCorp ($120K) and DataFlow ($48K) renewals due in Q2. Finn recommends setting aside $50K as contingency. If both renew, funds return to operating budget.' },
    { id: 'fd2', title: 'Approve salary band adjustment: Senior Developer +10% ($15K/yr impact)', agent: 'finn', urgency: 'medium', detail: 'Tali\'s recommendation to increase the Senior Developer salary band from $140-160K to $150-175K. Annual impact: $15K. Within budget — Finn confirms headcount budget has $42K remaining for Q1.' },
  ],

  financials: [
    { label: 'Cash Position', value: '$2.1M', detail: 'As of today' },
    { label: 'Monthly Burn', value: '$185K', detail: 'Avg. last 3 months' },
    { label: 'MRR', value: '$142K', detail: '+8% MoM' },
    { label: 'Runway', value: '11.4 mo', detail: 'At current burn' },
    { label: 'ARR', value: '$1.7M', detail: '+22% YoY' },
    { label: 'Gross Margin', value: '78%', detail: '+2% vs Q4' },
  ],

  metrics: [
    { label: 'Revenue', value: '$164K', trend: '+4% vs forecast', trendUp: true },
    { label: 'Burn Rate', value: '$185K', trend: 'Stable', trendUp: true },
    { label: 'Cash', value: '$2.1M', trend: '+$48K MoM', trendUp: true },
    { label: 'Overdue Invoices', value: '3', trend: '+2', trendUp: false, alert: true },
    { label: 'Budget Variance', value: '-$2.1K', trend: 'Meta overrun', trendUp: false },
    { label: 'Collections', value: '96%', trend: '+2%', trendUp: true },
  ],

  recentActivity: [
    { id: 'fra1', agent: 'finn', action: 'flagged Marketing Meta Ads budget overrun — $2,100 over approved spend', time: '45 min ago', type: 'alert' },
    { id: 'fra2', agent: 'finn', action: 'completed January revenue reconciliation — $164K actual vs $158K forecast', time: '1 hr ago', type: 'action' },
    { id: 'fra3', agent: 'finn', action: 'modeled Q2 runway scenarios based on Enterprise renewal outcomes', time: '2 hrs ago', type: 'insight' },
    { id: 'fra4', agent: 'finn', action: 'queued 3 overdue vendor invoices ($14,200) for payment processing', time: '3 hrs ago', type: 'action' },
    { id: 'fra5', agent: 'finn', action: 'confirmed headcount budget has $42K remaining for Tali\'s salary adjustment request', time: '4 hrs ago', type: 'action' },
    { id: 'fra6', agent: 'finn', action: 'identified $22K/month in non-essential expenses for potential runway extension', time: '5 hrs ago', type: 'insight' },
    { id: 'fra7', agent: 'finn', action: 'updated gross margin calculation — improved to 78% from 76% in Q4', time: 'Yesterday', type: 'action' },
    { id: 'fra8', agent: 'finn', action: 'prepared board-ready financial summary for Q1 review', time: 'Yesterday', type: 'action' },
  ],
};

export const FINANCE_DEPT_CHAT_RESPONSES = {
  deepDive: {
    text: "Here's my strategic analysis of Finance.\n\nThe financial position is strong — cash at $2.1M, burn stable at $185K/month, and revenue 4% ahead of forecast. Two items need awareness:",
    actions: [
      { agent: 'finn', label: 'Meta Ads budget overrun ($2,100) — cross-referenced with Marsi, reallocation already in motion', status: 'complete' },
      { agent: 'finn', label: 'Q2 runway: 11.4 months base case, drops to 9.8 if Enterprise renewals slip. Contingency reserve recommended', status: 'pending-approval' },
      { agent: 'finn', label: '3 vendor invoices overdue ($14.2K) — processing queued, automated reminders being set up', status: 'in-progress' },
      { agent: 'finn', label: 'Tali\'s salary band adjustment ($15K/yr) confirmed within headcount budget — $42K remaining', status: 'pending-approval' },
    ],
    timeline: 'January close is on track. Variance report will be ready by 3 PM today. No action items blocking the month-end close.',
  },
  general: {
    text: "I'm monitoring Finance. Here's the snapshot:\n\nCash is healthy at $2.1M with 11.4 months of runway. Revenue came in 4% above forecast in January at $164K.\n\nThe main flag is a Marketing budget overrun on Meta Ads ($2,100 over). Marsi already recommended reallocating that budget, so this should self-correct.\n\nOne strategic consideration: if either Enterprise renewal (TechCorp or DataFlow) slips, runway drops to 9.8 months. I've modeled the scenarios and recommend a $50K contingency reserve.\n\nWant me to walk through the numbers?",
  },
};
